<ng-container *ngIf="checklist$ | async as checklist; else noChecklist">
    <app-fcp-card
        title="{{ ('aumico_reports_checklist_title' | i18next) + ': ' + activeTestGroupItem.name }}"
        icon="assets/hamIcons/list-outline.svg"
        [expanded]="expanded"
        (expandedChange)="updateCardExpandedState($event)"
    >
        <div class="action-buttons">
            <span
                *ngIf="!showChecklistForm"
                class="edit-item"
                hamIconShapes
                icon="assets/hamIcons/edit-outline.svg"
                [variant]="'transparent'"
                [size]="'regular'"
                [type]="'circle'"
                (click)="onEditChecklist(checklist)"
            ></span>
            <span
                *ngIf="!showChecklistForm && !activeTestItem && activeTestGroupItem?.tasks?.length"
                class="edit-item"
                hamIconShapes
                icon="assets/hamIcons/trash-outline.svg"
                [variant]="'transparent'"
                [size]="'regular'"
                [type]="'circle'"
                (click)="showDeleteChecklistDialog = true"
            ></span>
        </div>

        <div class="checklist-view" *ngIf="!showChecklistForm && checklist">
            <div *ngFor="let task of checklist.tasks; let i = index" class="checkbox-container">
                <span
                    class="custom-checkbox"
                    hamCheckbox
                    [checked]="task.isDone"
                    (change)="onTaskChange($event, checklist, task, i)"
                >
                    {{ task.text }}
                </span>
                <div class="task-info" *ngIf="task.isDone && activeTestItem != null">
                    <app-editor-meta-info [meta]="{ createdByName: task.doneByName, createdAt: task.doneAt }">
                    </app-editor-meta-info>
                </div>

                <div *ngIf="i < checklist.tasks.length - 1" class="spacer"></div>
            </div>
        </div>
        <div class="checklist-container" *ngIf="showChecklistForm">
            <tasks-form
                [checkListTasks]="selectedChecklist?.tasks"
                (onSubmitChecklistForm)="onSubmit($event)"
                (onCancelCheckList)="onCancel()"
                (markTaskToRemove)="onMarkTaskToRemove($event)"
            ></tasks-form>
        </div>
    </app-fcp-card>
</ng-container>

<ng-template #noChecklist>
    <app-fcp-card
        icon="assets/hamIcons/list-outline.svg"
        title="{{ 'aumico_reports_checklist_title' | i18next }}"
        [expanded]="expanded"
        (expandedChange)="updateCardExpandedState($event)"
    >
        <div class="checklist-container" *ngIf="!showChecklistForm">
            <div class="checklist-container--no-data">
                <p>{{ 'aumico_reports_no_checklist_message' | i18next }}</p>
                <div class="checklist-container--no-data__action">
                    <ham-button outline="true" (click)="onImportChecklist()">{{
                        'aumico_reports_import_checklist_button' | i18next
                    }}</ham-button>
                    <ham-button (click)="onCreateCheckList()">{{
                        'aumico_reports_create_checklist_button' | i18next
                    }}</ham-button>
                </div>
            </div>
        </div>
        <div class="checklist-container" *ngIf="showChecklistForm">
            <tasks-form
                [checkListTasks]="selectedChecklist?.tasks"
                (onSubmitChecklistForm)="onSubmit($event)"
                (onCancelCheckList)="onCancel()"
                (markTaskToRemove)="onMarkTaskToRemove($event)"
            ></tasks-form>
        </div>
    </app-fcp-card>
</ng-template>

<ham-modal
    *ngIf="displayChecklistSelectionModal"
    saveText="{{ 'aumico_reports_fcp_save_checklist_button' | i18next }}"
    (cancel)="onCancelChecklistModal()"
    (save)="onSelectChecklistFromModal()"
    title="{{ 'aumico_reports_import_checklist' | i18next }}"
>
    <app-import-checklist-modal
        [data]="dialogData"
        (rowSelected)="onRowInModalSelected($event)"
    ></app-import-checklist-modal>
</ham-modal>
<ham-confirm-decline-modal
    class="confirm-decline-modal"
    *ngIf="showMarkAllAsDoneDialog"
    (cancel)="onCancelMarkTaskInAllAccountsAsDone()"
    (action)="onConfirmMarkTaskInAllAccountsAsDone()"
    footerAlignment="start"
    title="{{ 'aumico_reports_fcp_closing_process_checklist_mark_all_as_done' | i18next }}"
    actionBtnText="{{ 'aumico_reports_fcp_closing_process_checklist_mark_all_as_done_confirm' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_fcp_closing_process_checklist_mark_all_as_done_cancel' | i18next }}"
>
    <mark-all-as-done (dontAskAgainChange)="onDontAskAgainChange($event)"></mark-all-as-done>
</ham-confirm-decline-modal>

<ham-confirm-decline-modal
    class="confirm-decline-modal"
    *ngIf="showDeleteChecklistDialog"
    (cancel)="showDeleteChecklistDialog = false"
    (action)="onDeleteChecklist()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <delete-checklist-modal></delete-checklist-modal>
</ham-confirm-decline-modal>
